<upp-application menu="hide">
    <upp-application-page>
        <!--
          POS mobile pattern (place/upp-view + place/upp-cart): one shell panel;
          main chrome/tabs hide while ticket/table Attention/cart fill panel-content via a shell.
          Settings stays a sibling panel (distinct flow), same as before.
        -->
        <upp-panel
            [hidden]="ShowSettings"
            lines="hide"
            size="auto"
            uppDataid="ptf-home"
        >
            <upp-panel-header [hidden]="work?.HideTabs">
                <upp-header color="warning" lines="light" menu="hide">
                    <upp-header-title uppDataid="ptf-home-place-name">
                        {{ place?.name || tr('@place_no_name') }}
                    </upp-header-title>
                    <upp-header-button
                        *ngIf="work?.ShowFloorToggle"
                        size="large"
                        uppDataid="ptf-home-floor-toggle"
                        (click)="OnFloorOptions()"
                    >
                        <ion-icon name="map-outline"></ion-icon>
                    </upp-header-button>
                    <upp-header-button size="large" uppDataid="ptf-home-settings" (click)="OnOpenSettings()">
                        <ion-icon name="settings-outline"></ion-icon>
                    </upp-header-button>
                </upp-header>

                <ion-item *ngIf="ShowUnlinkedWarning"
                    uppDataid="ptf-home-unlinked"
                    color="warning"
                    class="warning"
                    lines="none"
                >
                    <ion-icon slot="start" name="alert-circle-outline"></ion-icon>
                    <ion-label>
                        {{ tr('@ptf_unlinked_title') }}<br/>
                        <span class="small">{{ tr('@ptf_unlinked_subtitle') }}</span>
                    </ion-label>
                </ion-item>

                <ion-item *ngIf="ShowNotTerminalWarning"
                    uppDataid="ptf-home-notterminal"
                    color="warning"
                    class="warning"
                    lines="none"
                >
                    <ion-icon slot="start" name="phone-portrait-outline"></ion-icon>
                    <ion-label>
                        {{ tr('@ptf_notterminal_title') }}<br/>
                        <span class="small">{{ tr('@ptf_notterminal_subtitle') }}</span>
                    </ion-label>
                </ion-item>

                <upp-scrollable *ngIf="work?.ShowFloorRow" class="floor-plans-scroll" [scrollbar]="'x'" uppDataid="ptf-home-floor-bar">
                    <div class="floor-plans-row">
                        <button
                            type="button"
                            uppDataid="ptf-tables-floor-grid"
                            [ngClass]="{ 'is-selected': work?.IsFloorSelected(null) }"
                            (click)="OnSelectFloor(null)"
                        >
                            <ion-icon name="grid-outline"></ion-icon>
                        </button>
                        <button
                            *ngFor="let area of work?.Floors ?? []; trackBy: FloorTrack"
                            type="button"
                            [uppDataid]="'ptf-tables-floor-' + (area.name || area._uuid || '')"
                            [ngClass]="{ 'is-selected': work?.IsFloorSelected(area) }"
                            (click)="OnSelectFloor(area)"
                        >
                            <upp-image [readonly]="true" [src]="area.photo || area.avatar"></upp-image>
                            <span>{{ area.name || tr('@place_table_area_noname') }}</span>
                        </button>
                    </div>
                </upp-scrollable>
            </upp-panel-header>

            <upp-panel-content>
                <div class="ptf-home-main" [hidden]="work?.HideTabs">
                    <upp-pinpad-work #workHost [ticketsTpl]="ticketsTpl"></upp-pinpad-work>
                </div>

                <ng-container *ngIf="work as workRef">
                    <div
                        *ngIf="workRef.ShowDetail && ticketDetailTpl"
                        class="ptf-home-panel-shell"
                        uppDataid="ptf-work-ticket-detail"
                    >
                        <ng-container
                            *ngTemplateOutlet="ticketDetailTpl; context: { $implicit: workRef }"
                        ></ng-container>
                    </div>

                    <div
                        *ngIf="workRef.ShowTable && tableDetailTpl"
                        class="ptf-home-panel-shell"
                        uppDataid="ptf-work-table-detail"
                    >
                        <ng-container
                            *ngTemplateOutlet="tableDetailTpl; context: { $implicit: workRef }"
                        ></ng-container>
                    </div>

                    <div
                        *ngIf="workRef.ShowCart && cartTpl"
                        class="ptf-home-panel-shell"
                        uppDataid="ptf-work-cart"
                    >
                        <ng-container *ngTemplateOutlet="cartTpl"></ng-container>
                    </div>
                </ng-container>
            </upp-panel-content>

            <upp-panel-footer [hidden]="work?.HideTabs">
                <upp-tab-bar
                    [selected]="work?.tab ?? 'tables'"
                    (Selected)="OnWorkTab($event)"
                >
                    <upp-tab-button
                        uppDataid="ptf-work-tab-tables"
                        tabname="tables"
                        tabicon="restaurant"
                        tablabel="{{ tr('@place_placeorder_tab') }}"
                    ></upp-tab-button>
                    <upp-tab-button
                        uppDataid="ptf-work-tab-tickets"
                        tabname="tickets"
                        tabicon="receipt-outline"
                        tablabel="{{ tr('@place_viewtickets_tab') }}"
                    ></upp-tab-button>
                </upp-tab-bar>
            </upp-panel-footer>
        </upp-panel>

        <upp-panel *ngIf="ShowSettings" lines="hide" size="auto" uppDataid="ptf-settings">
            <upp-panel-header>
                <upp-header color="warning" lines="light" menu="hide">
                    <upp-header-title>
                        {{ tr('@ptf_settings_title') }}
                    </upp-header-title>
                    <upp-header-button size="large" uppDataid="ptf-settings-back" (click)="OnCloseSettings()">
                        <ion-icon name="arrow-back-outline"></ion-icon>
                    </upp-header-button>
                </upp-header>
            </upp-panel-header>

            <upp-panel-content>
                <upp-form>
                    <upp-form-section fill="clear">
                        <upp-language-select
                            uppDataid="ptf-settings-language"
                            [ngModel]="CurrentLanguage"
                            [title]="tr('@user_current_language')"
                            (Changed)="OnLanguage($event)"
                        ></upp-language-select>
                    </upp-form-section>

                    <div class="ptf-settings-separator" aria-hidden="true"></div>

                    <upp-form-section title="{{ tr('@ptf_settings_appearance') }}">
                        <ion-item>
                            <ion-label>{{ tr('@place_edit_option_scrollbar') }}</ion-label>
                            <ion-checkbox
                                uppDataid="ptf-settings-scrollbar"
                                slot="end"
                                [checked]="view.Scrollbar"
                                (ionChange)="OnScrollbar($event)"
                            ></ion-checkbox>
                        </ion-item>

                        <ion-item
                            uppDataid="ptf-settings-theme"
                            [lines]="view.CanZoom ? 'full' : 'none'"
                            button
                            detail="false"
                            (click)="OnChangeTheme()"
                        >
                            <ng-container *ngIf="view.LightTheme === true">
                                <ion-label>{{ tr('@place_edit_option_lighttheme') }}</ion-label>
                                <ion-icon slot="end" name="sunny-outline"></ion-icon>
                            </ng-container>
                            <ng-container *ngIf="view.LightTheme !== true">
                                <ion-label>{{ tr('@place_edit_option_darktheme') }}</ion-label>
                                <ion-icon slot="end" name="moon-outline"></ion-icon>
                            </ng-container>
                        </ion-item>

                        <ion-item *ngIf="view.CanZoom" lines="none" class="ptf-home__zoom" uppDataid="ptf-settings-zoom">
                            <ion-label>
                                <h2>{{ tr('@ptf_size_label') }}</h2>
                                <p>{{ ZoomPercent }}%</p>
                            </ion-label>
                            <ion-range
                                slot="end"
                                [min]="50"
                                [max]="100"
                                [step]="5"
                                [value]="ZoomPercent"
                                (ionChange)="OnZoomPercent($event)"
                            ></ion-range>
                        </ion-item>
                    </upp-form-section>

                    <upp-form-section
                        uppDataid="ptf-settings-service-refresh"
                        title="{{ tr('@place_device_connection_status') }}"
                        icon="refresh-outline"
                        slot="end"
                        (click)="OnRefreshServiceStatus()"
                    >
                        <ion-item lines="none" class="ptf-settings-service-name">
                            <ion-label class="ion-text-center">
                                <p>{{ tr('@place_till_edit_service') }}</p>
                                <div
                                    class="ptf-settings-service-name__value"
                                    uppDataid="ptf-settings-service-name"
                                >{{ ConfiguredServiceName }}</div>
                            </ion-label>
                        </ion-item>
                    </upp-form-section>

                    <div class="ptf-settings-service-status">
                        <upp-form-section fill="clear">
                            <upp-form-warning
                                uppDataid="ptf-settings-service-status"
                                [color]="ServiceStatusColor"
                                slot="start"
                                [icon]="ServiceStatusIcon"
                                [title]="ServiceStatusTitle"
                                [subtitle]="ServiceStatusMessage"
                            ></upp-form-warning>
                        </upp-form-section>
                    </div>
                </upp-form>
            </upp-panel-content>

            <upp-panel-footer class="ptf-settings-footer">
                <button
                    *ngIf="CanChangePlace"
                    type="button"
                    class="ptf-settings-footer__item"
                    uppDataid="ptf-settings-change-place"
                    (click)="OnChangePlace()"
                >
                    <span>{{ tr('@ptf_home_change_place') }}</span>
                    <ion-icon name="swap-horizontal-outline" aria-hidden="true"></ion-icon>
                </button>
                <button
                    type="button"
                    class="ptf-settings-footer__item"
                    uppDataid="ptf-settings-logout"
                    (click)="OnLogout()"
                >
                    <span>{{ tr('@ptf_home_logout') }}</span>
                    <ion-icon name="log-out-outline" aria-hidden="true"></ion-icon>
                </button>
            </upp-panel-footer>
        </upp-panel>
    </upp-application-page>
</upp-application>
